const template = require('./calendarHeatMap.template');
import './calendarHeatMap.styles';

export interface CalendarHeatMapDay{
    date: Date;
    count: number;
}

export default class CalendarHeatMap implements ng.IComponentController{
	public static $inject = [
	];
	
    public items: CalendarHeatMapDay[];
    public days:number;
    public dayIndex:number;
    public beginDate:Date;
	public endDate:Date;
	private itemsProcessed:boolean = false;

	constructor(){
	}

	public $doCheck = function(){
		if (this.items && !this.itemsProcessed) {
			this.sortItems();
		}
	}.bind(this);

	private sortItems(){
		this.items.sort((a,b)=>{ return b.date < a.date ? 1 : -1;});

		this.beginDate = !this.beginDate ? this.items[0].date : this.beginDate;
		this.endDate = !this.endDate ? this.items[this.items.length-1].date : this.endDate;
	}
}

export const CalendarHeatMapComponent:ng.IComponentOptions  =  {
	template,
	controller: CalendarHeatMap,
	controllerAs:'vm',
	bindings: {
		selectedDate: '=',
		beginDate: '@',
		endDate: '@',
		items: '='
	}
};

export function HightlightDaysDirective($interval:ng.IIntervalService, $timeout: ng.ITimeoutService) {
	return {
		restrict: 'A',
		require: '^^sbCalendarHeatMap',
		scope: false,
		controller: [()=>{}],
		link: function(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any, vm: CalendarHeatMap) {
			// https://regex101.com/r/K9X51L/1
			const mdCalendarIdPattern = /md-([0-9]|[1-9][0-9]|100)-month-/;
			let calendarScroller: ng.IAugmentedJQuery;
			let calendarPrefix:string;

			let t = $interval(() => {
				let elm = angular.element(document.querySelector('md-calendar .md-calendar-scroll-mask .md-virtual-repeat-offsetter'));
				if(!elm){return;}	

				let prefixElm = document.querySelector('md-calendar .md-calendar-date[id]');
				if(!prefixElm){return;}
				if(!calendarPrefix){
					let id = document.querySelector('md-calendar .md-calendar-date[id]').id;
					let matches = id.match(mdCalendarIdPattern);
					calendarPrefix = matches[0];
				}

				calendarScroller = elm;

				styleCalendar();
					
				calendarScroller.parent().on('scroll', e=>{
					styleCalendar();
				});
				
				$interval.cancel(t);

				scope.$watchCollection('vm.items',newVal=>{
					if(!newVal){ return; }
					
					styleCalendar();
				});

			}, 200);

			function styleCalendar(){
				if(!calendarPrefix){
					let id = document.querySelector('md-calendar .md-calendar-date[id]').id;
					let matches = id.match(mdCalendarIdPattern);
					calendarPrefix = matches[0];
				}
		
				let dailyActivities = vm.items;
				dailyActivities.forEach(a=>{
                    let elementId = a.date.getFullYear() + '-' + a.date.getMonth() + '-' + a.date.getDate();
					let e = document.getElementById(calendarPrefix + elementId);
					if(e){
						let styleClass="";
						let count = a.count;

						//TODO - come up with a better way to dynamically figure out top 25% and lower 25% count
						if(count >=30){ styleClass = 'heat-map---high'}
						else if(count<30 && count>=5){ styleClass = 'heat-map---medium'}
						else if(count>0 && count<5){ styleClass = 'heat-map---low'}
						angular.element(e).addClass(styleClass);
					}
				});
			}

		}
	};
}
HightlightDaysDirective.$inject = [
	'$interval',
	'$timeout'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/calendarHeatMap/calendarHeatMap.ts